var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "109px",
    height: "110px",
    viewBox: "0 0 92.441 103.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_44",
    "data-name": "Gruppe 44",
    transform: "translate(-373.222 -272.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36",
    "data-name": "Gruppe 36",
    transform: "translate(388.076 287.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_75",
    "data-name": "Pfad 75",
    d: "M477.288,347.19a15.361,15.361,0,0,0-5.105-11.444,15.387,15.387,0,0,0-6.92-25.839l.551-1.432a15.419,15.419,0,0,0-15.264-17.531,15.377,15.377,0,0,0-12.009,5.753l-.089,76.37a15.409,15.409,0,0,0,27.507-9.544l-.042-1.46A15.416,15.416,0,0,0,477.288,347.19Z",
    transform: "translate(-399.7 -290.841)",
    fill: "#cedbef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_76",
    "data-name": "Pfad 76",
    d: "M417.708,290.818A15.409,15.409,0,0,0,402.3,306.227l.042,1.46a15.4,15.4,0,0,0-6.266,26.318A15.386,15.386,0,0,0,403,359.844l-.552,1.432a15.572,15.572,0,0,0-.144,2.123,15.409,15.409,0,0,0,27.418,9.655l.088-76.37A15.38,15.38,0,0,0,417.708,290.818Z",
    transform: "translate(-390.971 -290.818)",
    fill: "#cedbef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_37",
    "data-name": "Gruppe 37",
    transform: "translate(400.375 298.937)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(8.484 0)",
    fill: "#4890ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(44.592 29.581)",
    fill: "#4890ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(36.772 57.658)",
    fill: "#4890ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(11.34 40.585)",
    fill: "#4890ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(0 27.818)",
    fill: "#4890ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(33.407 17.277)",
    fill: "#4890ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_38",
    "data-name": "Gruppe 38",
    transform: "translate(431.865 315.347)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(0 0)",
    strokeWidth: 4,
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_24",
    "data-name": "Linie 24",
    x1: 5.66,
    transform: "translate(8.608 4.304)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_43",
    "data-name": "Gruppe 43",
    transform: "translate(375.222 274.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_77",
    "data-name": "Pfad 77",
    d: "M404.512,305.661a15.409,15.409,0,1,1,12.1-24.953",
    transform: "translate(-377.774 -274.844)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_78",
    "data-name": "Pfad 78",
    d: "M380.472,321.973a15.411,15.411,0,0,1,6.122-26.46",
    transform: "translate(-375.222 -278.644)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_79",
    "data-name": "Pfad 79",
    d: "M401.23,350.447a15.409,15.409,0,0,1-20.676-22.829",
    transform: "translate(-375.341 -284.547)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80",
    "data-name": "Pfad 80",
    d: "M416.521,372.95A15.409,15.409,0,0,1,389.1,363.3a15.558,15.558,0,0,1,.145-2.123",
    transform: "translate(-377.774 -290.716)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_81",
    "data-name": "Pfad 81",
    d: "M462.287,329.564a15.412,15.412,0,0,1-6.122,26.46",
    transform: "translate(-390.103 -284.904)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_82",
    "data-name": "Pfad 82",
    d: "M438.377,301.087a15.409,15.409,0,0,1,20.676,22.829",
    transform: "translate(-386.833 -278.998)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_83",
    "data-name": "Pfad 83",
    d: "M449.876,292.375A15.41,15.41,0,0,0,422.6,280.6l-.088,76.37a15.409,15.409,0,1,0,12.1-24.952",
    transform: "translate(-383.917 -274.844)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_39",
    "data-name": "Gruppe 39",
    transform: "translate(20.498 11.012)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    strokeWidth: 4,
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_25",
    "data-name": "Linie 25",
    x1: 9.415,
    transform: "translate(8.608 4.304)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40",
    "data-name": "Gruppe 40",
    transform: "translate(39.467 68.576)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(9.415)",
    strokeWidth: 4,
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_26",
    "data-name": "Linie 26",
    x2: 9.415,
    transform: "translate(0 4.304)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_41",
    "data-name": "Gruppe 41",
    transform: "translate(23.459 51.495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    strokeWidth: 4,
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_27",
    "data-name": "Linie 27",
    x1: 5.66,
    transform: "translate(8.608 4.304)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_42",
    "data-name": "Gruppe 42",
    transform: "translate(6.395 38.855)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(5.66)",
    strokeWidth: 4,
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_28",
    "data-name": "Linie 28",
    x2: 5.66,
    transform: "translate(0 4.304)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 4.304,
    cy: 4.304,
    r: 4.304,
    transform: "translate(45.419 28.23)",
    strokeWidth: 4,
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_29",
    "data-name": "Linie 29",
    x2: 5.66,
    transform: "translate(39.759 32.534)",
    fill: "none",
    stroke: "#0b3558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.dc700827a7c004e44a15f37f3eb1d54c.svg";
export { ForwardRef as ReactComponent };